module.exports = __webpack_public_path__ + "static/media/shape.4bf16748.svg";